// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-561ade93] input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px var(--color-gray-20) inset!important}[data-v-561ade93] input:-webkit-autofill+label{transform:translateY(-.9285714286rem) scale(.75)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
